import { Fragment, useState } from "react";
import {
  Box,
  Collapse,
  Divider,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import { navMenus, routes } from "../../utils/routes";
import { Link, useLocation } from "react-router-dom";
import logo_b from "../../assets/images/logo_b.png";
import { styles } from "../../assets/styles";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import ArrowCircleDownRoundedIcon from "@mui/icons-material/ArrowCircleDownRounded";

function DrawerMenu({ setMobileOpen }) {
  const [currentMenu, setCurrentMenu] = useState({});
  const { pathname } = useLocation();

  const handleClick = (item) => {
    if (item.childMenu) {
      setCurrentMenu({ [item.name]: !currentMenu[item.name] });
    } else {
      if (!item?.fromChild) {
        setCurrentMenu({ [item.name]: !currentMenu[item.name] });
      }
      setMobileOpen(false);
    }
  };

  return (
    <Box sx={{ textAlign: "center", width: 300 }}>
      <Box
        sx={{
          ...styles.sideMenuInnerCont,
        }}
      >
        <Link
          to={routes.home}
          onClick={() => setMobileOpen(false)}
          style={{ flex: 1 }}
        >
          <Box
            sx={{
              ...styles.flexCenter,
              color: "#000dc1",
              fontFamily: "Broadway, Arial, sans-serif",
            }}
          >
            <Box sx={{ ...styles.sideMenuLogo }}>
              <img src={logo_b} alt="Briozon-Logo" />
            </Box>
            Briozon
          </Box>
        </Link>
        <IconButton onClick={() => setMobileOpen(false)}>
          {/* <CloseRoundedIcon sx={{ ...styles.sideMenuCloseIcon }} /> */}
          <ArrowCircleDownRoundedIcon sx={{ ...styles.sideMenuCloseIcon }} />
          {/* <KeyboardBackspaceRoundedIcon sx={{ ...styles.sideMenuCloseIcon }} /> */}
        </IconButton>
      </Box>
      <Divider />
      <List>
        {navMenus.map((item, index) => {
          let hasChild = item.children ? item.children.length > 0 : false;
          const isParentActive = hasChild
            ? item.children.some((c) => pathname === c.route) || pathname === item.route
            : pathname === item.route;
          return (
            <Fragment key={item.name}>
              {hasChild ? (
                <Box>
                  <ListItem
                    sx={{
                      ...styles.sideBarMenuItem,
                      py: 0.8,
                      width: "100%",
                      borderLeft: isParentActive ? "3px solid #5b7cfa" : "3px solid transparent",
                      color: isParentActive ? "#5b7cfa" : styles.sideBarMenuItem.color,
                      background: isParentActive ? "rgba(91,124,250,0.07)" : "transparent",
                      borderRadius: "0 8px 8px 0",
                    }}
                    onClick={() =>
                      handleClick({
                        name: item.name,
                        childMenu: true,
                        fromChild: false,
                      })
                    }
                  >
                    {item.name}{" "}
                    <ArrowDropUpRoundedIcon
                      sx={{
                        ...styles.menuArrowIcon,
                        transform: currentMenu[item.name] && "rotate(180deg)",
                      }}
                    />
                  </ListItem>

                  <Collapse
                    in={currentMenu[item.name]}
                    timeout={"auto"}
                    id={item.name}
                  >
                    <List component="div" disablePadding sx={{ pl: 2 }}>
                      {currentMenu[item.name]
                        ? item.children.map((child, index) => {
                          const isChildActive = pathname === child.route;
                          return (
                            <Fragment key={child.name}>
                              <ListItem
                                sx={{
                                  fontWeight: isChildActive ? 700 : 400,
                                  borderLeft: isChildActive ? "3px solid #5b7cfa" : "3px solid transparent",
                                  background: isChildActive ? "rgba(91,124,250,0.07)" : "transparent",
                                  borderRadius: "0 8px 8px 0",
                                  "& a": { color: isChildActive ? "#5b7cfa" : "inherit" },
                                }}
                                onClick={() =>
                                  handleClick({
                                    name: child.name,
                                    childMenu: false,
                                    fromChild: true,
                                  })
                                }
                              >
                                <Link to={child.route}>{child.name}</Link>{" "}
                              </ListItem>
                            </Fragment>
                          );
                        })
                        : null}
                    </List>
                  </Collapse>
                  {/* <Divider /> */}
                </Box>
              ) : (
                <>
                  <ListItem
                    sx={{
                      ...styles.sideBarMenuItem,
                      borderLeft: isParentActive ? "3px solid #5b7cfa" : "3px solid transparent",
                      background: isParentActive ? "rgba(91,124,250,0.07)" : "transparent",
                      borderRadius: "0 8px 8px 0",
                      "& a": { color: isParentActive ? "#5b7cfa" : "inherit", fontWeight: isParentActive ? 700 : 500 },
                    }}
                    onClick={() =>
                      handleClick({
                        name: item.name,
                        childMenu: false,
                        fromChild: false,
                      })
                    }
                  >
                    <Link to={item.route}>{item.name}</Link>
                  </ListItem>
                  {/* <Divider /> */}
                </>
              )}
            </Fragment>
          );
        })}
      </List>
    </Box>
  );
}

export default DrawerMenu;
